// Utility for date formatting - migrated from moment to dayjs
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/pt-br';

// Configure dayjs plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.locale('pt-br');

/**
 * Date utilities to replace moment.js functionality
 */
export const dateUtils = {
  /**
   * Format current date to YYYY
   */
  getCurrentYear: () => dayjs().format('YYYY'),
  
  /**
   * Format date to DD/MM/YYYY
   */
  formatDate: (date: string | Date) => {
    const dayjsDate = dayjs(date);
    return dayjsDate.isValid() ? dayjsDate.format('DD/MM/YYYY') : '';
  },
  
  /**
   * Check if date is valid
   */
  isValid: (date: string | Date) => dayjs(date).isValid(),
  
  /**
   * Get current date instance
   */
  now: () => dayjs(),
  
  /**
   * Parse date
   */
  parse: (date: string | Date) => dayjs(date),
  
  /**
   * Format date with custom format
   */
  format: (date: string | Date, format: string) => {
    const dayjsDate = dayjs(date);
    return dayjsDate.isValid() ? dayjsDate.format(format) : '';
  }
};

export default dateUtils;
